import { InvoiceEventType } from '../enums/invoiceEventType'
import { InvoiceEvent } from '../types/invoices/invoiceEvent'

const manualDeliveryEventTypes = [InvoiceEventType.DeliveryManualSent, InvoiceEventType.DeliveryManualUnsent]

// The events list keeps the full history, so a past "manually sent" event stays in it even after
// unmarking. Only the most recent manual delivery event tells us the current manual sent state.
export const isInvoiceManuallyMarkedAsSent = (events: InvoiceEvent[] = []): boolean => {
  const latestManualDeliveryEvent = events.find((event) => manualDeliveryEventTypes.includes(event.eventType))

  return latestManualDeliveryEvent?.eventType === InvoiceEventType.DeliveryManualSent
}
